import { render } from "./Accomodations.vue?vue&type=template&id=3c142561"
import script from "./Accomodations.vue?vue&type=script&lang=js"
export * from "./Accomodations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__